function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconSummerVacationFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.619 17.637h2c0-.84.844-1.521 1.88-1.521 1.039 0 1.883.681 1.883 1.52h2c0-1.94-1.742-3.52-3.882-3.52s-3.881 1.58-3.881 3.52zM25.499 28h2v-7.363h-2V28zm-12-.001h2v-7.363h-2v7.363zm4 .001h6v-7.363h-6V28zm11-9.364H12.5a1 1 0 00-1 1V29a1 1 0 001 1h16a1 1 0 001-1v-9.364a1 1 0 00-1-1zm-23.496-4.49a7.388 7.388 0 011.195-5.874c.004 1.19.264 2.542.82 4.075l1.88-.683c-.671-1.844-.88-3.39-.605-4.47.208-.818.678-1.35 1.439-1.628.76-.277 1.465-.173 2.148.32.907.653 1.74 1.971 2.41 3.815l1.88-.685c-.552-1.514-1.208-2.725-1.958-3.634.412.111.818.25 1.212.432a7.393 7.393 0 013.446 3.284L5.003 14.145zm16.15-4.814a9.38 9.38 0 00-4.883-5.33 9.377 9.377 0 00-6.264-.606l-.223-.613a1 1 0 00-1.88.683l.225.615a9.362 9.362 0 00-4.41 4.49 9.392 9.392 0 00-.315 7.221.995.995 0 001.28.597l6.997-2.546 1.38 3.793h2.129l-1.63-4.477 6.996-2.546a.998.998 0 00.598-1.28z",
    fill: props.color
  }));
}

export default SvgIconSummerVacationFilled;